import { Grid, Typography, useTheme } from "@mui/material";
import React from "react";

export default function InputDisplay({ label, value}) {
 const theme = useTheme();

  return (
    <>
      <Grid item xs={4}>
        <Typography variant="body2" gutterBottom className="card-text">
          <span style={{ color: theme.palette.primary.main,fontWeight:"bold" }}>{label}</span>{" "}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography variant="body2" gutterBottom className="card-text">
          {value}
        </Typography>
      </Grid>
    </>
  );
}
